<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.booking')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle('header.mall') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="banner"></div>
    <div class="cart-bar">
      <div class="my-cart" @click="toCart()">
        <img src="@/assets/images/icon-cart.png" />
        <span>我的购物车</span>
        <span class="sl">{{ cartNum }}</span>
        <span>&gt;</span>
      </div>
    </div>
    <div class="main">
      <div class="detail">
        <vk-data-goods-sku-popup
          v-if="sku_key"
          :custom-action="findGoodsInfo"
          :detailImageArray="goodsDetail.m_pics"
          :mode="1"
          @buy-now="buyNow"
          @add-cart="addCart"
        ></vk-data-goods-sku-popup>
      </div>
      <div class="description">
        <div class="title">
          <h2>商品详情</h2>
        </div>
        <div class="layout">
          <dl class="clearfix">
            <dt>商品名称：</dt>
            <dd>{{ goodsDetail.name }}</dd>
          </dl>
          <dl class="clearfix">
            <dt>商品编号：</dt>
            <dd>{{ goodsDetail.code }}</dd>
          </dl>
          <dl
            class="clearfix"
            v-for="(attrItem, attrIndex) in detailAttrsKeys"
            :key="attrIndex"
          >
            <dt>{{ attrItem }}：</dt>
            <dd>{{ detailAttrsValues[attrIndex] }}</dd>
          </dl>
          <dl class="clearfix">
            <dt>细节：</dt>
            <dd>
              <p v-html="goodsDetail.desc"></p>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import routerTo from '@/router/routerTo';
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import vkDataGoodsSkuPopup from '@/components/vk-data-goods-sku-popup/vk-data-goods-sku-popup.vue';
import mall from '@/api/mall';
import { getImageAllUrl } from '@/setup/common';
export default {
  components: { vkDataGoodsSkuPopup },
  data() {
    return {
      // 是否打开SKU弹窗
      sku_key: false,
      goodsDetail: {},
      goodsNewDetail: {},
      goodsId: '',
      detailAttrsKeys: [],
      detailAttrsValues: [],
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    cartNum() {
      return this.$store.getters.cartAllNumShow;
    },
  },
  mounted() {},
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    this.goodsId = this.$route.query.goodsId;
    this.getGoodsDetail();
  },
  methods: {
    toCart() {
      routerTo.FormDetailToCart(this.$router, false);
    },
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    async getGoodsDetail() {
      const getGoodsDetail = await mall.getGoodsDetail({
        product_code: process.env.VUE_APP_MALL_PRODUCT_CODE, //TOOD
        goods_id: this.goodsId,
      });
      this.goodsDetail = getGoodsDetail;
      this.goodsNewDetail = this.combinationShopData();
      this.sku_key = true;
      this.detailAttrsKeys = Object.keys(this.goodsDetail.attrs);
      this.detailAttrsValues = Object.values(this.goodsDetail.attrs);
    },
    allImageUrl(imagePath) {
      return getImageAllUrl(imagePath);
    },
    addCart(selectShop) {
      console.log('监听 - 加入购物车', selectShop);
      let newSelectShop = selectShop;
      newSelectShop.merchant_code = this.goodsDetail.merchant_code;
      this.$store.commit('addCartItem', selectShop);
    },
    // 立即购买
    buyNow(selectShop) {
      console.log('监听 - 确定', selectShop);
      let newSelectShop = selectShop;
      newSelectShop.merchant_code = this.goodsDetail.merchant_code;
      routerTo.toSubmitOrder(this.$router, false, {
        goodsDetail: JSON.stringify(selectShop),
      });
      /*
      this.sku_key = false;
      this.goodsItem = selectShop;
      if(this.cartOrBuyIndex == 0){
        cart.addCartItem(selectShop);
        this.options[0].info =  this.cartAllNumShow;
      }
      if(this.cartOrBuyIndex == 1){
        uni.navigateTo({
          url: `/pages/submitOrders/submitOrders?goodsDetail=${JSON.stringify(selectShop)}`,
        });
      }*/
    },
    //组装新的数据格式
    combinationShopData() {
      if (
        JSON.stringify(this.goodsDetail) != '{}' &&
        this.goodsDetail &&
        typeof this.goodsDetail == 'object'
      ) {
        let newGoodsDict = {};
        newGoodsDict._id = this.goodsDetail.id;
        newGoodsDict.name = this.goodsDetail.name;
        newGoodsDict.goods_thumb = this.allImageUrl(this.goodsDetail.s_pic);
        let sku_list = [];
        this.goodsDetail.spec.forEach((item) => {
          let newItem = {};
          newItem._id = this.goodsDetail.id;
          newItem.goods_id = item.spec_id;
          newItem.goods_name = this.goodsDetail.name;
          newItem.image = this.allImageUrl(item.img); //(this.goodsDetail.s_pic);
          newItem.price = item.price;
          let sku_name_arr = [];
          if (this.goodsDetail.spec_qty == 1) {
            sku_name_arr.push(item.spec_v1);
          }
          if (this.goodsDetail.spec_qty == 2) {
            sku_name_arr.push(item.spec_v1);
            sku_name_arr.push(item.spec_v2);
          }
          newItem.sku_name_arr = sku_name_arr;
          newItem.stock = item.stock;
          sku_list.push(newItem);
        });
        newGoodsDict.sku_list = sku_list;
        let spec_list = [];
        let specItem = {};
        let specItemCList = [];
        /*if (this.goodsDetail.spec_qty == 0) {
        }*/
        if (this.goodsDetail.spec_qty == 1) {
          specItem.name = this.goodsDetail.spec_k1;
          this.goodsDetail.spec.forEach((spec_item) => {
            specItemCList.push({ name: spec_item.spec_v1 });
          });
          for (var i = 0; i < specItemCList.length; i++) {
            for (var j = i + 1; j < specItemCList.length; j++) {
              if (specItemCList[i].name == specItemCList[j].name) {
                specItemCList.splice(j, 1);
                j--;
              }
            }
          }
          specItem.list = specItemCList;
          spec_list.push(specItem);
        }
        if (this.goodsDetail.spec_qty == 2) {
          let specItemOne = {};
          let specItemTwo = {};
          let specItemCListOne = [];
          let specItemCListTwo = [];
          specItemOne.name = this.goodsDetail.spec_k1;
          specItemTwo.name = this.goodsDetail.spec_k2;
          this.goodsDetail.spec.forEach((spec_item) => {
            specItemCListOne.push({ name: spec_item.spec_v1 });
            specItemCListTwo.push({ name: spec_item.spec_v2 });
          });
          for (var k = 0; k < specItemCListOne.length; k++) {
            for (var q = k + 1; q < specItemCListOne.length; q++) {
              if (specItemCListOne[k].name == specItemCListOne[q].name) {
                specItemCListOne.splice(q, 1);
                q--;
              }
            }
          }
          for (var m = 0; m < specItemCListTwo.length; m++) {
            for (var n = m + 1; n < specItemCListTwo.length; n++) {
              if (specItemCListTwo[m].name == specItemCListTwo[n].name) {
                specItemCListTwo.splice(n, 1);
                n--;
              }
            }
          }
          specItemOne.list = specItemCListOne;
          specItemTwo.list = specItemCListTwo;
          spec_list.push(specItemOne);
          spec_list.push(specItemTwo);
        }
        newGoodsDict.spec_list = spec_list;
        /*console.log('组装的数据格式是', JSON.stringify(newGoodsDict));*/
        return newGoodsDict;
      }
    },
    findGoodsInfo() {
      return this.goodsNewDetail;
      /*
      return {
        _id: '002',
        name: '迪奥香水',
        goods_thumb:
          'https://res.lancome.com.cn/resources/2020/9/11/15998112890781924_920X920.jpg?version=20200917220352530',
        sku_list: [
          {
            _id: '004',
            goods_id: '002',
            goods_name: '迪奥香水',
            image:
              'https://res.lancome.com.cn/resources/2020/9/11/15998112890781924_920X920.jpg?version=20200917220352530',
            price: 19800,
            sku_name_arr: ['50ml/瓶', 'S'],
            stock: 100,
          },
          {
            _id: '005',
            goods_id: '002',
            goods_name: '迪奥香水',
            image:
              'https://res.lancome.com.cn/resources/2020/9/11/15998112890781924_920X920.jpg?version=20200917220352530',
            price: 9800,
            sku_name_arr: ['70ml/瓶', 'L'],
            stock: 100,
          },
        ],
        spec_list: [
          {
            list: [
              {
                name: '20ml/瓶',
              },
              {
                name: '50ml/瓶',
              },
              {
                name: '70ml/瓶',
              },
            ],
            name: '规格',
          },
          {
            list: [
              {
                name: 'M',
              },
              {
                name: 'L',
              },
              {
                name: 'S',
              },
            ],
            name: '尺寸',
          },
        ],
      };
      */
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.banner {
  height: 240px;
  margin-bottom: 0;
  background-image: url(../../assets/images/banner-4.jpg);
}
.cart-bar {
  width: 1100px;
  height: 54px;
  margin: 0 auto;
  padding: 10px 0;
  z-index: 99;
  text-align: right;
  .my-cart {
    display: flex;
    justify-content: space-between;
    float: right;
    padding: 6px 10px;
    border: 1px solid #eee;
    border-radius: 4px;
    background: #f8f8f8;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
    }
    span {
      margin-left: 6px;
    }
    .sl {
      width: 20px;
      border-radius: 4px;
      color: #fff;
      text-align: center;
      background: #f15b49;
    }
  }
}
.main {
  width: 1100px;
  margin: 0 auto 40px;
  padding: 40px 40px;
  background: #fff;
  .detail {
    margin-bottom: 20px;
    background: #fff;
  }
  .description {
    margin-bottom: 20px;
    line-height: 28px;
    background: #fff;
    .title {
      margin-bottom: 20px;
      background: #f5f5f5;
      h2 {
        display: inline-block;
        padding: 0 30px;
        color: #fff;
        font-weight: normal;
        font-size: 14px;
        line-height: 40px;
        background: #31a775;
      }
    }
    .layout {
      dt {
        float: left;
        width: 100px;
        text-align: right;
      }
      dd {
        margin-left: 110px;
      }
    }
  }
}
</style>
